import {getWebBaseUrl} from "./getWebBaseUrl";
import {t} from "@lingui/macro";
import queryString from "query-string";
import {Type} from "../helper";

function throwError(errorMsg = '', allowNotFound = false) {
    if (!allowNotFound)
        throw new Error(errorMsg);
    return '';
}

function isViewable(type) {
    switch (type) {
        case Type.opening_balance:
        case Type.opening:
        case Type.opening_stock_adjustment:
        case Type.asset_depreciation:
        case Type.asset_disposal:
        case Type.bank_adjustment:
            return false;
        default:
            return true;
    }
}

export const TransactionUrl = {
    new: (type, allowNotFound = false) => {
        const baseUrl = getWebBaseUrl(type, allowNotFound);
        return `${baseUrl}/new`;
    },
    view: (type, id, allowNotFound = false) => {
        const baseUrl = getWebBaseUrl(type, allowNotFound);
        if (!isViewable(type))
            return null;
        if (!id)
            return throwError(t`getWebUrl READ: Must provide id: ${id}`, allowNotFound);
        return `${baseUrl}/${id}`;
    },
    pay: (type, fromType, id, allowNotFound = false) => {
        const baseUrl = getWebBaseUrl(type, allowNotFound);
        if (!id)
            return throwError(t`getWebUrl PAY: Must provide id: ${id}`, allowNotFound);
        if (!fromType)
            return throwError(t`getWebUrl PAY: Must provide type for action: ${fromType}`, allowNotFound);

        const query = queryString.stringify({action: 'pay', type: fromType, id});
        return `${baseUrl}/new?${query}`;
    },
    duplicate: (type, id, allowNotFound = false) => {
        const baseUrl = getWebBaseUrl(type, allowNotFound);
        if (!id)
            return throwError(t`getWebUrl DUPLICATE: Must provide id: ${id}`, allowNotFound);

        const query = queryString.stringify({action: 'duplicate', id});
        return `${baseUrl}/new?${query}`;
    },
    transfer: (type, fromType, id, allowNotFound = false) => {
        const baseUrl = getWebBaseUrl(type, allowNotFound);
        if (!id)
            return throwError(t`getWebUrl TRANSFER: Must provide id: ${id}`, allowNotFound);
        if (!fromType) {
            return throwError(
                t`getWebUrl TRANSFER: Must provide type for action: ${fromType}`, allowNotFound,
            );
        }

        const query = queryString.stringify({action: 'transfer', type: fromType, id});
        return `${baseUrl}/new?${query}`;
    },
    copy: (type, fromType, id, allowNotFound = false) => {
        const baseUrl = getWebBaseUrl(type, allowNotFound);
        if (!id)
            return throwError(t`getWebUrl COPY: Must provide id: ${id}`, allowNotFound);
        if (!fromType)
            return throwError(t`getWebUrl COPY: Must provide type for action: ${fromType}`, allowNotFound);

        const query = queryString.stringify({action: 'copy', type: fromType, id});
        return `${baseUrl}/new?${query}`;
    },
    copy_items: (type, fromType, id, allowNotFound = false) => {
        const baseUrl = getWebBaseUrl(type, allowNotFound);
        if (!id)
            return throwError(t`getWebUrl COPY: Must provide id: ${id}`, allowNotFound);
        if (!fromType)
            return throwError(t`getWebUrl COPY: Must provide type for action: ${fromType}`, allowNotFound);

        const query = queryString.stringify({action: 'copy-items', type: fromType, id});
        return `${baseUrl}/new?${query}`;
    },
    batch: (type, allowNotFound = false) => {
        const baseUrl = getWebBaseUrl(type, allowNotFound);
        return `${baseUrl}/batch`;
    },
    list: (type, allowNotFound = false) => getWebBaseUrl(type, allowNotFound),
    recurring: (type, id) => {
        const query = queryString.stringify({action: 'recurring', id, type});
        return `/cp/instructions/new?${query}`;
    },
};
